import { Box } from "@mui/material";
import moment from "moment";
import ActionBar from "../../../components/Actionbar/ActionBars";
import Header from "../../../components/Header/Header";
import ProjectHeader from "../../../components/Header/ProjectHeader";
import DashboardTable from "../../../components/Table/DashboardTable";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import "../../../components/dataTable.scss";
import * as val from "../../../redux/validator/actions";
import { clearApiStatus } from "../../../redux/pre_processor/actions";
import constant from "../../../constants/constantValues";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";
import PendingFiles from "../../../components/PendingFiles";

const Index = () => {
  const dispatch = useDispatch();
  const [projects, setProjects] = useState([]);
  const fromState = useSelector((state) => state?.vali?.valProject);
  const [notification, setNotification] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [list, setList] = useState([]);
  const [openFileStatusDialog, setOpenFileStatusDialog] = useState(false);

  const apiStatus = useSelector((state) => state?.prePro?.apiStatus);
  const projectFromState = useSelector(
    (state) => state?.vali?.valProject?.data?.validator_projects
  );
  const type = useSelector((state) => state?.prePro?.type);
  const pendinBatchesList = useSelector(
    (state) => state?.shared?.pendinBatchesList
  );

  const {
    PROJECT_HEADER,
    PROJECT_NAME,
    BATCH_NAME,
    COUNT,
    END_DATE,
    STATUS,
    ASSIGNED,
    LAST_UPDATED,
    ACTION,
  } = constant;

  useEffect(() => {
    if (apiStatus?.apiError) {
      setMessage(apiStatus.message);
      setSeverity("error");
      setNotification(true);
    }
  }, [apiStatus]);

  useEffect(() => {
    dispatch(clearApiStatus());
    dispatch(
      val.getValidatorList({
        type: "",
        formattedStartDate: "",
        formattedEndDate: "",
        status: "",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (projectFromState?.length > 0) {
      setProjects([...projectFromState]);
    } else {
      setProjects([]);
    }
  }, [type, projectFromState]);

  useEffect(() => {
    if (pendinBatchesList?.data?.validator_projects?.length > 0) {
      setList(pendinBatchesList?.data?.validator_projects);
    }
  }, [pendinBatchesList?.data?.validator_projects]);

  const onSearch = (word, type) => {
    let result;
    let filteredProjects = [];


    if (!projectFromState || !Array.isArray(projectFromState)) {
      setProjects([]);
      return;
    }

    if (type === "project") {
      if (word) {
        result = projectFromState?.filter(function (el) {
          return (
            el?.project_name
              .toString()
              .toLowerCase()
              .indexOf(word.toLowerCase()) !== -1
          );
        });
      } else {
        result = projectFromState;
      }
    } else {
      if (word) {
        projectFromState?.map((item, index) => {
          const filteredBatches = item?.batch_info?.filter(function (el) {
            return (
              el?.batch_name
                .toString()
                .toLowerCase()
                .indexOf(word.toLowerCase()) !== -1
            );
          });
          if (filteredBatches.length > 0) {
            filteredProjects.push({
              ...projectFromState[index],
              batch_info: filteredBatches,
            });
          } else {
          }
        });
        result = filteredProjects;
      } else {
        result = projectFromState;
      }
    }
    setProjects([...result]);
  };

  const filterByDate = (startDate, endDate, status) => {
    const formattedStartDate =
      startDate !== "" ? moment(startDate).format("YYYY-MM-DD") : "";
    const formattedEndDate =
      endDate !== "" ? moment(endDate).format("YYYY-MM-DD") : "";

    dispatch(
      val.getValidatorList({
        type,
        formattedStartDate,
        formattedEndDate,
        status,
      })
    );
  };
  const clear = () => {
    dispatch(clearApiStatus());
    dispatch(
      val.getValidatorList({
        type: "",
        formattedStartDate: "",
        formattedEndDate: "",
        status: "",
      })
    );
  };

  let header = [
    PROJECT_NAME,
    BATCH_NAME,
    COUNT,
    END_DATE,
    STATUS,
    ASSIGNED,
    LAST_UPDATED,
    ACTION,
  ];

  const onClickViewPendingBatches = () => {
    setOpenFileStatusDialog(true);
  };

  return (
    <>
      <Header />
      <ActionBar
        onSearch={(value, type) => onSearch(value, type)}
        filterByDate={filterByDate}
        clear={clear}
        onClickViewPendingBatches={onClickViewPendingBatches}
        list={list}
      />
      <ProjectHeader text={PROJECT_HEADER} headerColor="white" style={{paddingTop:"10px"}}/>
      {fromState?.loader ? (
        <DashboardTableSkaleton />
      ) : (
        <Box>
          <DashboardTable header={header} projects={projects} />
        </Box>
      )}
      {notification && (
        <CustomizedSnackbars
          severity={severity}
          state={notification}
          text={message}
          handleClose={() => setNotification(false)}
        />
      )}
      <PendingFiles
        openFileStatusDialog={openFileStatusDialog}
        setOpenFileStatusDialog={setOpenFileStatusDialog}
        list={list}
      />
    </>
  );
};

export default Index;
